<template>
  <div class="row">
    <div class="span8 list-main">
      <h3 class="list-title" style="font-size: 22px;">二手交易中心</h3>
      <ul class="tabs-nav">
        <li :class="{ active: pagelistquery.lable === '' }" @click="changelable('')">全部</li>
        <li v-for="item in lables" :key="item" :class="{ active: pagelistquery.lable === item }" @click="changelable(item)">{{ item }}</li>
      </ul>
      <div class="stuff-grid">
        <div class="stuff-card" v-for="item in tableData" :key="item.oldstuff_id">
          <router-link :to="`/oldstuffcontent/${item.oldstuff_id}`" class="thumbnail">
            <img :src="item.oldstuff_img" />
            <div class="caption">
              <div class="price">￥{{ item.oldstuff_price }}</div>
              <div class="name">{{ item.oldstuff_name }}</div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="pagination-wrap">
        <el-pagination
          layout="prev, pager, next"
          :total="pagelistquery.total"
          :page-size="12"
          @current-change="getlist"
        ></el-pagination>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <activity-widget />
      <news-widget />
    </div>
  </div>
</template>

<script>
import carouselWidget from '@/components/carousel.vue'
import activityWidget from '@/components/activity.vue'
import newsWidget from '@/components/news.vue'
import { getOldstuffList, getLable } from '@/api'

export default {
  name: 'Oldstuff',
  components: { carouselWidget, activityWidget, newsWidget },
  data() {
    return {
      lables: [],
      tableData: [],
      pagelistquery: { lable: '', page: 1, total: 0 }
    }
  },
  created() {
    getLable('二手分类').then((res) => {
      this.lables = JSON.parse(res.data[0].lable) || []
    })
    this.getlist(1)
  },
  methods: {
    getlist(page) {
      this.pagelistquery.page = page
      getOldstuffList({ ...this.pagelistquery, pagesize: 12 }).then((res) => {
        this.tableData = res.data || []
        this.pagelistquery.total = res.count || 0
      })
    },
    changelable(lable) {
      this.pagelistquery.lable = lable
      this.getlist(1)
    }
  }
}
</script>
